import { jwtDecode } from "jwt-decode";
import { keycloakConfig } from "config";
import { User } from "oidc-client-ts";
import { useAuth } from "react-oidc-context";

interface JwtPayload {
    realm_access: {
        roles: string[];
    };
}
  
export const realmAccessRoles = (token: string): string[] => {
    const decodedToken = jwtDecode<JwtPayload>(token);
    if (!decodedToken) {
        throw new Error("Failed to decode jwt token");
    }
    return decodedToken.realm_access.roles;
}

/**
 * Retrieves user's access token from keycloak storage, to be used only in scenarios when user is not accessible from react 
 * state, i.e. by using the useAuth hook
 * 
 * @returns access_token
 */
export const accessToken = async (): Promise<string | null> => {
    const oidcStorage = await keycloakConfig.userStore!.get(`user:${keycloakConfig.authority}:${keycloakConfig.client_id}`);
    if (!oidcStorage) {
        return null;
    }
    return User.fromStorageString(oidcStorage).access_token;
}

export const useRoles = () : string[] | null => {
    const auth = useAuth();
    const roles = auth?.user ? realmAccessRoles(auth.user!.access_token) : null;
    return roles;
};